import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routerList = [];

function importAll (r) {
  r.keys().forEach(
    key => routerList.push(r(key).default)
  )
}

importAll(require.context('./', true, /\.router\.js/))

const routes = [
  {
    path: '/',
    redirect: '/dealer/index',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => import('../views/login/forget-password.vue'),
  },
  ...routerList
]

const router = new VueRouter({
  routes
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
